import { setTokens, clearTokens } from '@crm/utils';
import { getApiClient } from './client';
import type { CurrentUser } from './types/user';

/** Login credentials */
export interface LoginCredentials {
  email: string;
  password: string;
}

/** Login response */
export interface LoginResponse {
  access: string;
  refresh: string;
  user: CurrentUser;
}

/** Login and store tokens */
export async function login(credentials: LoginCredentials): Promise<CurrentUser> {
  const client = getApiClient();
  // Use custom login endpoint that returns user data with tokens
  const response = await client.post<LoginResponse>('/api/v1/auth/login/', credentials);
  
  setTokens(response.data.access, response.data.refresh);
  return response.data.user;
}

/** Logout and clear tokens */
export async function logout(): Promise<void> {
  try {
    const client = getApiClient();
    await client.post('/api/v1/auth/logout/');
  } finally {
    clearTokens();
  }
}

/** Get current authenticated user */
export async function getCurrentUser(): Promise<CurrentUser> {
  const client = getApiClient();
  const response = await client.get<CurrentUser>('/api/v1/auth/me/');
  return response.data;
}

/** Refresh access token */
export async function refreshToken(): Promise<boolean> {
  // This is handled by the client interceptor
  // Exposed for manual refresh if needed
  try {
    const client = getApiClient();
    await client.post('/api/v1/auth/token/refresh/');
    return true;
  } catch {
    return false;
  }
}
